import { Form, Select } from 'antd'
import { useMemo, useState } from 'react'

export default function Check({ parameters, fieldName }) {
  const [selectedValue, setSelectedValue] = useState([])
  const available = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr
      .map(({ name }) => name)
      .filter((item) => !selectedValue.includes(item))
      .map((item) => ({ label: item, value: item }))
  }, [parameters, selectedValue])

  return (
    <>
      <Form.Item
        label={'Horário de início'}
        rules={[
          {
            required: true,
            message: 'É preciso escolher um parametro do gatilho',
          },
        ]}
        name={[fieldName, 'action', 'data', 'start']}
      >
        <Select
          placeholder={'Início'}
          options={available}
          onChange={(value) => setSelectedValue(value)}
        />
      </Form.Item>
      <Form.Item
        label={'Horário de encerramento'}
        rules={[
          {
            required: true,
            message: 'É preciso escolher um parametro do gatilho',
          },
        ]}
        name={[fieldName, 'action', 'data', 'end']}
      >
        <Select
          placeholder={'Fim'}
          options={available}
          onChange={(value) => setSelectedValue(value)}
        />
      </Form.Item>
    </>
  )
}
